import makeBlockie from 'ethereum-blockies-base64';
import { AddressZero } from '@ethersproject/constants';

type AvatarProps = {
    userAddress?: string | null;
};

const Avatar: React.FC<AvatarProps> = ({ userAddress }) => {
    return (
        <img
            className='avatar'
            src={makeBlockie(userAddress || AddressZero)}
            alt='blockie avatar'
        />
    );
};

export default Avatar;
